export default function Accessibility() {

  return (

    <div className="container-narrow">

      <div className="card">

        <h1>Accessibility Help</h1>

        <p>

          Hopeful Horizons NY is committed to making our website accessible to all individuals, including those with disabilities.

        </p>

        <p>

          We aim to provide a website that is easy to navigate, readable, and compatible with assistive technologies.

        </p>

        <p>

          If you experience difficulty accessing any part of the website or need assistance, please contact us and we will work to provide support.

        </p>

      </div>

    </div>

  );

}